/**
 * @file: Strategy.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 策略管理
 */
import request from '@/utils/request'

/**
 * 删除全部策略
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function strategyDelete(data) {
  return request({
    type: 'device',
    url: 'strategy/delete',
    method: 'post',
    data
  })
}

/**
 * 获取策略详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function strategyGet(data) {
  return request({
    type: 'device',
    url: 'strategy/get',
    method: 'post',
    data
  })
}

/**
 * 修改策略
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function strategyUpdate(data) {
  return request({
    type: 'device',
    url: 'strategy/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Strategy.js